import { render } from "./login-transit.vue?vue&type=template&id=5180245e&scoped=true&ts=true"
import script from "./login-transit.vue?vue&type=script&lang=ts"
export * from "./login-transit.vue?vue&type=script&lang=ts"

import "./login-transit.vue?vue&type=style&index=0&id=5180245e&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5180245e"]])

export default __exports__